import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import sectiondata from "../../data/sections.json";
import parse from "html-react-parser";
import { GetPropertyList } from "../../request/apiRquest";
import { GetBuildingTypeList } from "../../request/apiRquest";
//import { GetSearchBy_CityBy_Location } from "../../request/apiRquest";
import Chips from "react-chips";
import { useHistory } from "react-router-dom";


const Banner = () => {

  const history = useHistory()

  const [buildingTypeList, setBuildingTypeList] = useState([]);
  const [chips, setChips] = useState([]);
  const [propertyFor, setPropertyFor] = useState("1");
  const [selectBuildingType, setSelectedBuildingType] = useState("2");
  const [selectedConstructionType, setSelectedConstructionType] = useState("0");





  // const getpropertylist = () => {
  //   GetPropertyList().then((res) => {
  //     setProperties(res);
  //   })
  // }

  const getbuildingTypeList = () => {
    GetBuildingTypeList().then((res) => {
      setBuildingTypeList(res);
    })
  }

  useEffect(() => {
    //   getpropertylist();
    getbuildingTypeList();
  }, [])

  const getsearchbylocation = () => {
    // GetSearchBy_CityBy_Location().then((res) => {
    //   setSearchLocation()
    // })
  }

  useEffect((id, city) => {
    getsearchbylocation(id, city)
  }, [])


  const handleSearch = () => {
    const queryParams = new URLSearchParams();
    if (propertyFor) queryParams.append("PropertyFor", propertyFor);
    if (selectBuildingType) queryParams.append("PropertyType", selectBuildingType);
    if (selectedConstructionType) queryParams.append("Ready_Underconstruction", selectedConstructionType);
    history.push(`/search-grid?${queryParams.toString()}`);
  }


  let publicUrl = process.env.PUBLIC_URL + "/";
  let imagealt = "image";
  let data = sectiondata.banner;

  const inlineStyle = {
    backgroundImage: "url("  + "/assets/img/banner/landing.jpg)",
  };

  return (
    <div className="banner-area jarallax" style={inlineStyle}>
      <div className="container">
        <div className="banner-inner-wrap">
          <div className="row">
            <div className="col-12">
              <div className="banner-inner">
                {/* <h5 className="sub-title">{data.subtitle}</h5> */}
                <h1
                  className="title"
                  style={{
                    textShadow: "2px 2px 8px rgba(255, 255, 255, 0.8)",
                    color: "#FDA94F" // light glow
                  }}
                >
                  {data.title1} <br /> {data.title2}
                </h1>
              </div>
            </div>
            <div className="col-12">
              <div className="banner-search-wrap">
                <ul className="nav nav-tabs rld-banner-tab">
                  <li className="nav-item">
                    <a
                      className={`nav-link ${propertyFor === "1" ? "active" : ""}`}
                      onClick={() => setPropertyFor("1")}
                      style={{ cursor: "pointer" }}
                    >
                      For Buy
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className={`nav-link ${propertyFor === "2" ? "active" : ""}`}
                      onClick={() => setPropertyFor("2")}
                      style={{ cursor: "pointer" }}
                    >
                      For Rent
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div className="tab-pane fade show active" id="tabs_1">
                    <div className="rld-main-search">
                      <div className="row">
                        {/* <div className="col-xl-3 col-lg-6 col-md-6">
                          <div className="rld-single-input left-icon">
                            <Chips
                              value={chips}
                             // onChange={onChange}
                             // suggestions={suggestions}
                              placeholder="Search By Location & City"
                            />
                          </div>
                        </div> */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                          <div className="rld-single-select">
                            <select className="select single-select" value={selectBuildingType} onChange={(e) => setSelectedBuildingType(e.target.value)}>
                              {buildingTypeList?.map((item) =>
                                <option key={item.id || item.name} value={item.id}>{item.name}</option>
                              )}
                              {/* <option value={1}>Property Type</option> */}
                            </select>
                          </div>
                        </div>
                        {/* <div className="col-xl-2 col-lg-4 col-md-4">
                            <div className="rld-single-select">
                              <select className="select single-select">
                                <option value={1}>Room</option>
                                <option value={2}>Room 1</option>
                                <option value={3}>Room 2</option>
                                <option value={3}>Room 3</option>
                              </select>
                            </div>
                          </div> */}
                        <div className="col-xl-4 col-lg-4 col-md-4">
                          <div className="rld-single-select">
                            <select className="select single-select" value={selectedConstructionType} onChange={(e) => setSelectedConstructionType(e.target.value)}>
                              <option  value="0">Completion status</option>
                              <option value="2">Ready</option>
                               <option value="3">Off-plan</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-4 readeal-top">
                          <button className="btn btn-yellow" onClick={handleSearch}>
                            SEARCH NOW
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

}

export default Banner;
